import { useOptimizeExperiment } from '@eb/google-optimize-utils';
import { useState } from 'react';

const FOLLOW_COUNT_EXPERIMENT = 'X6QS5eNNQv-yvej7Qyeldg';

/**
 * Enrolls the current user into the google optimize experiment. Returns
 * the enrolled variant as an element of state, which will trigger a re-render
 *
 * @returns string representing variant type
 */
export const useFollowCountExperiment = () => {
    const [showFollowingCountVariant, setShowFollowingCount] = useState(
        undefined,
    );

    useOptimizeExperiment({
        experimentName: FOLLOW_COUNT_EXPERIMENT,
        setVariantEnrollment: setShowFollowingCount,
    });

    return showFollowingCountVariant;
};
